var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-912 -880) translate(776 164) translate(136 716)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 2.333,
    x: 0.5,
    y: 9.833,
    fill: "#FA0000",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00368E",
    d: "M1.5 9.833h19c.552 0 1 .448 1 1v.334c0 .552-.448 1-1 1h-19c-.552 0-1-.448-1-1v-.334c0-.552.448-1 1-1z",
    transform: "rotate(-90 11 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.833 9.833H12.166V12.166H9.833z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDriver);
export default __webpack_public_path__ + "static/media/new_driver.bebf620a1422ae74189f14b55900df5c.svg";
export { ForwardRef as ReactComponent };